export default __webpack_public_path__ + "static/media/ffly4u.80d9007c.png";